<div ngbDropdown class="d-inline-block">

    <a id="user-circle" ngbDropdownToggle class="user-avatar">

        <fa-icon [icon]="faUserCircle" [size]="'lg'">
        </fa-icon>

    </a>

    <div ngbDropdownMenu aria-labelledby="user-circle" class="user-dropdown">

        <div class="user-info">

            <div>
                <div class="user-name">
                    {{ user.name }}
                </div>

                <div class="user-email">
                    {{ user.email }}
                </div>
            </div>
        </div>

        <div class="dropdown-divider"></div>

        <a ngbDropdownItem [routerLink]="['/app/support']">
            <fa-icon [icon]="faHeadset" class="me-2"></fa-icon>
            {{ 'SUPPORT' | translate }}
        </a>

        <a ngbDropdownItem class="logout-item" [routerLink]="['/auth/login']">
            <fa-icon [icon]="faSignOutAlt" class="me-2"></fa-icon>
            {{ 'LOGOUT' | translate }}
        </a>

    </div>


</div>